export const TWITTER_HANDLE_SUC = 'twitterHandle.save.success';;

export const twitterHandleSaveSuccess = (uuid, name) => ({
type: TWITTER_HANDLE_SUC,
uuid,
name,
});